import classNames from "classnames";
import Button from "../../../components/ui/Button";
import { toDecimalString } from "../../common/strings";
import styles from "../css/SlotProductView.module.css";
import { PurchaseProduct } from "../model/products";
import { useTranslation } from "react-i18next";

interface SlotProductViewProps {
  product: PurchaseProduct;
  // 지정하면 이 상품의 슬롯 단가로 환산한 정가와 할인율을 보여준다.
  compareProduct?: PurchaseProduct;
  // 인기 뱃지를 달고 카드를 강조한다.
  isBest?: boolean;
  onClickPurchaseButton: (product: PurchaseProduct) => void;
}

export default function SlotProductView(props: SlotProductViewProps) {
  const { t } = useTranslation();
  const price = "₩" + toDecimalString(props.product.price);

  const isBest = props.isBest ?? false;
  const regularPrice = props.compareProduct
    ? Math.round(
        (props.compareProduct.price / props.compareProduct.slotCount) *
          props.product.slotCount
      )
    : 0;
  const discountPercent = props.compareProduct
    ? Math.round((1 - props.product.price / regularPrice) * 100)
    : 0;

  return (
    <>
      <div className={classNames(styles.container, { [styles.best]: isBest })}>
        {isBest && (
          <span className={styles.bestBadge}>{t("SlotProductBestBadge")}</span>
        )}

        <span className={styles.slotPurchaseTitleText}>
          {props.product.name}
        </span>

        {discountPercent > 0 && (
          <div className={styles.discountRow}>
            <span className={styles.regularPriceText}>
              {"₩" + toDecimalString(regularPrice)}
            </span>
            <span className={styles.discountText}>
              {t("SlotProductDiscount", { percent: discountPercent })}
            </span>
          </div>
        )}

        <span className={styles.slotPriceText}>{price}</span>

        <Button
          size="lg"
          fullWidth
          variant={isBest ? "primary" : "secondary"}
          className={styles.buyButton}
          onClick={() => {
            props.onClickPurchaseButton(props.product);
          }}
        >
          {t("buynow")}
        </Button>
      </div>
    </>
  );
}
